import React, { Component } from 'react';

import { isEmpty } from '../../../Common/Common';

import Switch from '../../../Part_Sample/Switch';
import Select from '../../../Part_Sample/Select';

export default class Command_Alert extends Component {
	constructor(props) {
		super(props);

		this.condition_detail = JSON.parse(JSON.stringify(this.props.condition_detail));

		let value = true;
		let operator = '='
		if (this.condition_detail.value.fix != null) value = this.condition_detail.value.fix;
		if (this.condition_detail.condition != null) operator = this.condition_detail.condition;

		this.state = {
			operator: operator,
			value: value,
		}
	}

	handleChangeValue = (val) => {
		this.setState({ value: val });
		let value = {};
		value.fix = val;
		this.props.handleChangeStat(this.state.operator, value);
	}

	handleChangeOperator = (op) => {
		this.setState({ operator: op })
		let value = {};
		value.fix = this.state.value;
		this.props.handleChangeStat(op, value);
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
			marginTop: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		const range = [];
		range.push(<option selected value={true}>{this.props.receiver.getString('interlock_occur')}</option>);
		range.push(<option selected value={false}>{this.props.receiver.getString('clear')}</option>);

		const operators = [];
		operators.push(<option selected value={'='}>{'='}</option>);
		operators.push(<option selected value={'!='}>{'≠'}</option>);

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 5, marginLeft: 5, width: this.props.width - 210 }}>
					<span className='title'>{this.props.receiver.getString('alert')}</span>
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', width: 50 }}>
					<Select
						options={operators}
						value={this.state.operator}
						onSelect={this.handleChangeOperator}
					/>
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 20, width: 80 }}>
					<Select
						options={range}
						value={this.state.value}
						onSelect={this.handleChangeValue}
					/>
				</div>
			</div>
		)
	}
}